var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"inline-flex items-center mt-3"},[_c('input',{staticClass:"form-checkboxtext-gray-600",attrs:{"type":"checkbox","checked":""}}),_c('span',{staticClass:"ml-2 text-gray-700"},[_vm._v("label")])])
}]

export { render, staticRenderFns }